var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcvshop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 218,
    height: 228,
    viewBox: "0 0 218 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 218,
    height: 228
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 108.5,
    cy: 108.5,
    r: 108.5,
    transform: "translate(1 6)",
    fill: "#0395ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CCV_Shop_Logo_White",
    "data-name": "CCV Shop Logo White",
    transform: "translate(21.992 62.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81003",
    "data-name": "Path 81003",
    d: "M21.46,55.178A14.832,14.832,0,0,1,14.571,53.6a10.365,10.365,0,0,1-4.5-4.187l4.142-3.287a8.381,8.381,0,0,0,7.429,4.1,5.973,5.973,0,0,0,3.737-1.1,3.439,3.439,0,0,0,1.441-2.859q0-3.2-4.548-4.862L18.759,40.14a13.145,13.145,0,0,1-5.718-3.579,8.111,8.111,0,0,1-1.846-5.425,8.116,8.116,0,0,1,2.927-6.551A11.236,11.236,0,0,1,21.6,22.131a11.9,11.9,0,0,1,9.68,4.367l-3.647,3.557a7.627,7.627,0,0,0-6.078-2.972,6.239,6.239,0,0,0-3.579.991,3.1,3.1,0,0,0-1.463,2.7,3.322,3.322,0,0,0,1.1,2.634,12.587,12.587,0,0,0,3.759,1.959l3.241,1.216A13.591,13.591,0,0,1,30.24,40.23a8.289,8.289,0,0,1,1.891,5.718,8.373,8.373,0,0,1-2.972,6.686A11.423,11.423,0,0,1,21.46,55.178Z",
    transform: "translate(24.99 49.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81004",
    "data-name": "Path 81004",
    d: "M22.789,55.537H17.836V21.769h4.953V36.087q2.116-3.512,6.844-3.512a8.059,8.059,0,0,1,6.258,2.566,9.766,9.766,0,0,1,2.341,6.844V55.537H33.279V42.8a6.382,6.382,0,0,0-1.261-4.21A4.226,4.226,0,0,0,28.6,37.077a5.21,5.21,0,0,0-4.187,1.936,8.252,8.252,0,0,0-1.621,5.448Z",
    transform: "translate(44.283 48.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81005",
    "data-name": "Path 81005",
    d: "M36.844,43.691a6.339,6.339,0,0,0,4.84-2.049A7.139,7.139,0,0,0,43.6,36.577a7.141,7.141,0,0,0-1.913-5.065,6.8,6.8,0,0,0-9.725,0,7.138,7.138,0,0,0-1.914,5.065,7.136,7.136,0,0,0,1.914,5.065A6.388,6.388,0,0,0,36.844,43.691Zm8.4,1.193a11.408,11.408,0,0,1-8.4,3.4,11.61,11.61,0,0,1-11.8-11.706,11.61,11.61,0,0,1,11.8-11.706,11.608,11.608,0,0,1,11.8,11.706A11.3,11.3,0,0,1,45.241,44.884Z",
    transform: "translate(62.194 55.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81006",
    "data-name": "Path 81006",
    d: "M44.554,43.781a6.236,6.236,0,0,0,4.818-2.071,7.323,7.323,0,0,0,1.891-5.132,7.325,7.325,0,0,0-1.891-5.132,6.691,6.691,0,0,0-9.68,0A7.33,7.33,0,0,0,37.8,36.577a7.327,7.327,0,0,0,1.891,5.132A6.287,6.287,0,0,0,44.554,43.781ZM38.206,57.243H33.253V25.321h4.952v3.017A8.262,8.262,0,0,1,41.2,25.884a9.122,9.122,0,0,1,4.255-1.013,10.051,10.051,0,0,1,7.721,3.422,11.838,11.838,0,0,1,3.129,8.284,11.837,11.837,0,0,1-3.129,8.284,10.047,10.047,0,0,1-7.721,3.422A9.123,9.123,0,0,1,41.2,47.27a8.259,8.259,0,0,1-2.994-2.454Z",
    transform: "translate(82.577 55.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81007",
    "data-name": "Path 81007",
    d: "M59.811,9.251a6.874,6.874,0,1,1-6.874-6.874A6.874,6.874,0,0,1,59.811,9.251Z",
    transform: "translate(114.392 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81008",
    "data-name": "Path 81008",
    d: "M50.014,2.7,70.252,43.09,62.042,59.23,33.644,2.7Z",
    transform: "translate(83.547 0.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81009",
    "data-name": "Path 81009",
    d: "M57.817,36.968a13.669,13.669,0,1,1,.072-11.856l13.043-6.559a28.265,28.265,0,1,0-.1,25.022Z",
    transform: "translate(42.876 0.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81010",
    "data-name": "Path 81010",
    d: "M40.555,36.968a13.669,13.669,0,1,1,.072-11.856L53.67,18.552a28.265,28.265,0,1,0-.1,25.022Z",
    transform: "translate(0 0.805)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcvshop);
export default __webpack_public_path__ + "static/media/ccvshop.1da12584cf8f56671ac4b1ad1bab53a9.svg";
export { ForwardRef as ReactComponent };